import Typecheck from "../../utils/Typecheck";

export interface Reference {
    id: string
    title: string
}

export const isReference = (content: unknown): content is Reference => {
    return Typecheck.isObject(content)
        && Typecheck.has(content, 'id') && Typecheck.isString(content.id)
        && Typecheck.has(content, 'title') && Typecheck.isString(content.title);
}
